import { PropsWithChildren, createContext } from "react"
import { AppModule, app } from "./app.module"

export const AppContext = createContext<AppModule>(app)

export function AppProvider({ children }: PropsWithChildren) {
  return <AppContext.Provider value={app}>{children}</AppContext.Provider>
}
